(function () {
  if (typeof window !== 'undefined' && window.__swishContactPopupScriptLoaded) {
    return;
  }

  if (typeof window !== 'undefined') {
    window.__swishContactPopupScriptLoaded = true;
  }

  const MODAL_SELECTOR = '[data-contact-popup-modal]';
  const AUTO_OPEN_SELECTOR = '[data-contact-popup-auto-open="true"]';

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function normalizeKey(value) {
    return String(value || '')
      .replace(/^#/, '')
      .trim()
      .toLowerCase();
  }

  function getModals(root) {
    const scope = root && root.querySelectorAll ? root : document;
    const modals = toArray(scope.querySelectorAll(MODAL_SELECTOR));

    if (scope.matches && scope.matches(MODAL_SELECTOR)) {
      modals.unshift(scope);
    }

    return modals;
  }

  function getModalByKey(key) {
    const normalized = normalizeKey(key);
    if (!normalized) return null;

    return (
      getModals(document).find(function (modal) {
        return normalizeKey(modal.getAttribute('data-contact-popup-key')) === normalized;
      }) || null
    );
  }

  function safeClosest(target, selector) {
    if (!target || !selector) return null;

    try {
      return target.closest(selector);
    } catch (error) {
      return null;
    }
  }

  function getSelectorList(modal) {
    return String(modal.getAttribute('data-contact-popup-selectors') || '')
      .split(',')
      .map(function (selector) {
        return selector.trim();
      })
      .filter(Boolean);
  }

  function matchesCustomSelector(modal, target) {
    return getSelectorList(modal).some(function (selector) {
      return Boolean(safeClosest(target, selector));
    });
  }

  function openModal(modal, opener) {
    if (!modal) return;

    if (typeof modal.show === 'function') {
      modal.show(opener || document.body);
      return;
    }

    modal.setAttribute('open', '');
    document.body.classList.add('overflow-hidden');
  }

  function getKeyFromTrigger(trigger) {
    if (!trigger) return '';

    const explicitKey = trigger.getAttribute('data-contact-popup-trigger');
    if (explicitKey) return explicitKey;

    const href = trigger.getAttribute('href');
    if (!href) return '';

    if (href.charAt(0) === '#') {
      return href.slice(1);
    }

    try {
      const url = new URL(href, window.location.origin);
      if (url.origin === window.location.origin && url.pathname === window.location.pathname && url.hash) {
        return url.hash.slice(1);
      }
    } catch (error) {
      return '';
    }

    return '';
  }

  function maybeOpenFromDirectTrigger(event, target) {
    const trigger = target.closest('[data-contact-popup-trigger], a[href*="#"]');
    if (!trigger) return false;

    const modal = getModalByKey(getKeyFromTrigger(trigger));
    if (!modal) return false;

    event.preventDefault();
    openModal(modal, trigger);
    return true;
  }

  function maybeOpenFromSelector(event, target) {
    const modal = getModals(document).find(function (candidate) {
      return matchesCustomSelector(candidate, target);
    });

    if (!modal) return false;

    const opener = target.closest('a, button, [role="button"]') || target;
    event.preventDefault();
    openModal(modal, opener);
    return true;
  }

  function handleClick(event) {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    if (maybeOpenFromDirectTrigger(event, target)) return;
    maybeOpenFromSelector(event, target);
  }

  function autoOpenMarkedPopups(root) {
    getModals(root).forEach(function (modal) {
      if (modal.querySelector(AUTO_OPEN_SELECTOR)) {
        openModal(modal, document.body);
      }
    });
  }

  function autoOpenFromHash() {
    if (typeof window === 'undefined' || !window.location || !window.location.hash) return;

    const modal = getModalByKey(window.location.hash);
    if (modal) {
      openModal(modal, document.body);
    }
  }

  function init(root) {
    autoOpenMarkedPopups(root);

    if (root === document) {
      autoOpenFromHash();
    }
  }

  function scheduleInit(root) {
    if (typeof window !== 'undefined' && typeof window.requestAnimationFrame === 'function') {
      window.requestAnimationFrame(function () {
        init(root);
      });
      return;
    }

    setTimeout(function () {
      init(root);
    }, 0);
  }

  document.addEventListener('click', handleClick);

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        init(document);
      },
      { once: true }
    );
  } else {
    scheduleInit(document);
  }

  document.addEventListener('shopify:section:load', function () {
    scheduleInit(document);
  });
})();
